import { Component, Input, OnInit } from '@angular/core';
import { BikeService } from '../../../services/bike.service';
import { ComponentEditComponent } from '../component-edit/component-edit.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HelpersService } from '../../../services/helpers.service';
import { NewJobcardService } from '../../../services/new-jobcard.service';
import { WorkshopJobcardComponent } from '../workshop-jobcard/workshop-jobcard.component';

@Component({
  selector: 'app-item-service-history',
  templateUrl: './item-service-history.component.html',
  styleUrls: ['./item-service-history.component.scss']
})
export class ItemServiceHistoryComponent implements OnInit {

  @Input() bike: any;
  @Input() components: any[] = [];

  public serviceHistory: any[] = [];
  public selectedService: any = null;
  public loading: boolean = false;
  public distanceMetric: string = 'km';
  public expandedNotes: { [key: string]: boolean } = {};
  public showAddGear: boolean = false;
  public gear: any = {};
  public isDraggingGrid: boolean = false;
  private gridDragStartX: number = 0;
  private gridScrollStartX: number = 0;
  public partnerData: any;
  public countryData: any = {};
  public displayDateFormat: any = 'dd-MM-yyyy';
  public displayDateTimeFormat: any = 'dd-MM-yyyy HH:mm';
  public setCalendarTimeFormat: number = 24;

  constructor(private helpersService: HelpersService,
    private bikeService: BikeService, private modalService: NgbModal, private newJobcardService: NewJobcardService,) { }

  ngOnInit() {
    this.partnerData = this.helpersService.getPartnerData();
    if (this.bike && this.bike.ID) {
      this.loadServiceHistory();
      this.getBikeGear();
    }
    this.distanceMetric = this.helpersService.getDistanceMetric();
    this.countryData = this.helpersService.getCountryData();
    this.setCalendarTimeFormat = this.countryData.code == 'US' ? 12 : 24;
    this.displayDateFormat = this.countryData.AngularDateFormat;
    this.displayDateTimeFormat =
      this.countryData.AngularDateFormat;

  }


  loadServiceHistory() {
    this.loading = true;
    this.bikeService.getServiceHistoryForBike(this.bike.ID, this.bike.UserID).subscribe({
      next: (history: any[]) => {
        this.serviceHistory = (history || []).sort((a, b) =>
          new Date(b.serviceDate).getTime() - new Date(a.serviceDate).getTime()
        );
        if (this.serviceHistory.length > 0) {
          this.selectedService = this.serviceHistory[0];
        }
        this.loading = false;
      },
      error: () => { this.loading = false; }
    });
  }

  getBikeGear() {
    console.log('Loading bike gear for bike ID:', this.bike.ID);
    this.components = [];
    //TODO there is no units for Month, currently also a hack to figure out if KM or HRS is being used.
    this.showAddGear = false;
    this.bikeService.getActiveGear(this.bike.ID).subscribe(bikeGear => {
      console.log('Received bike gear:', bikeGear);
      this.components = bikeGear.filter((b) => {
        return b.status === 'Active';
      });
      //this.components = bikeGear;
    });
  }

  selectService(service: any) {
    this.selectedService = service;
    this.expandedNotes = {};
  }

  isOwnShop(service: any): boolean {
    return !service.storeName;
  }

  toggleNote(key: string) {
    this.expandedNotes[key] = !this.expandedNotes[key];
  }

  isExpanded(key: string): boolean {
    return !!this.expandedNotes[key];
  }

  getNotePreview(text: string): string {
    if (!text) return '';
    return text.length > 120 ? text.substring(0, 120) + '...' : text;
  }

  shouldTruncate(text: string): boolean {
    return text && text.length > 120;
  }

  getServiceIndicatorPercent(component: any): number {
    if (!component || !component.serviceInterval || component.serviceInterval === 0) return 0;
    return Math.min(Math.round((component.kmSinceLastService / component.serviceInterval) * 100), 100);
  }

  getServiceIndicatorClass(percent: number): string {
    if (percent < 75) return 'indicator--good';
    if (percent < 90) return 'indicator--warning';
    return 'indicator--critical';
  }

  getServiceTypes(service: any): string {
    if (!service) return '';
    return service.servicesDone || service.servicesDone || '';
  }

  addNewComponent() {
    this.gear = { BikeID: this.bike.ID, TypeID: 0 };
    this.showAddGear = !this.showAddGear;
  }

  editComponent(component: any) {
    console.log('Edit component:', component);
    this.gear = component;
    this.gear.BikeID = this.bike.ID;
    this.gear.TypeID = 0;
    this.showAddGear = !this.showAddGear;
  }

  onGridMouseDown(event: MouseEvent, el: HTMLElement) {
    this.isDraggingGrid = true;
    this.gridDragStartX = event.pageX - el.offsetLeft;
    this.gridScrollStartX = el.scrollLeft;
  }

  onGridMouseMove(event: MouseEvent, el: HTMLElement) {
    if (!this.isDraggingGrid) return;
    event.preventDefault();
    const x = event.pageX - el.offsetLeft;
    const walk = x - this.gridDragStartX;
    el.scrollLeft = this.gridScrollStartX - walk;
  }

  onGridMouseUp() {
    this.isDraggingGrid = false;
  }

  openJobCard(jobcardID) {
    console.log('Opening job card with ID:', jobcardID);
    console.log('Partner data:', this.partnerData);
    if (jobcardID.partnerId === this.partnerData.ID) {
      const modalRef = this.modalService.open(WorkshopJobcardComponent, {
        windowClass: 'workshop-jobcard-window workshop-jobcard-window-top jobcard-modal-popup-window-top',
        modalDialogClass: 'workshop-jobcard-modal-dialog workshop-jobcard-modal-dialog-top jobcard-modal-popup-window-top',
        backdrop: 'static',
      });

      modalRef.componentInstance.jobCardID = jobcardID.id;
      modalRef.componentInstance.goToMessaging = false;

      return modalRef.result.then(
        (result) => {
          return result;
        },
        (onrejected) => {
          throw onrejected;
        }
      );
    }
  }

}
